let TRIES

const MAX_TRIES = 500

const changeVisibility = style => {
  const CHAT_ID = 'crisp-chatbox'
  const chat = document.getElementById(CHAT_ID)

  if (TRIES > MAX_TRIES) {
    return
  }

  if (chat) {
    chat.style = style
  } else {
    TRIES++
    setTimeout(() => changeVisibility(style), 100)
  }
}

export const showChat = () => {
  TRIES = 0
  const SHOW = 'display:inherit !important;'
  changeVisibility(SHOW)
}

export const hideChat = () => {
  TRIES = 0
  const HIDE = 'display:none !important;'
  changeVisibility(HIDE)
}
